import React from "react";
const NoopRetentionStrategySummary = () => /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Index retention strategy:"), /* @__PURE__ */ React.createElement("dd", null, "Do nothing")));
export default NoopRetentionStrategySummary;
